import { render, staticRenderFns } from "./homeUd.vue?vue&type=template&id=64c6363a&scoped=true&"
import script from "./homeUd.vue?vue&type=script&lang=js&"
export * from "./homeUd.vue?vue&type=script&lang=js&"
import style0 from "./homeUd.vue?vue&type=style&index=0&id=64c6363a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c6363a",
  null
  
)

export default component.exports